import React, { useContext, useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { AccountListContext } from "../../../context/AccountListContext";
import { useUser } from "../../../context/UserContext";
import { COMPANY_LOGO_BASE_URL } from "../../../config/apiConfig";
import {
  formatValueInBillions,
  numberWithCommas,
} from "../../../services/commonService";
import * as FeatherIcon from "react-feather";
import TR3DotMenu from "../../Frontend/genericComponents/genericTableComp/TR3DotMenu";
import Modal from "react-bootstrap/Modal";
import { Button } from "react-bootstrap";
import Autocomplete from "../../HtmlElements/Autocomplete";
import api from "../../../services/api";
import ScreenLoader from "../../HtmlElements/ScreenLoader";
import Multiselect from "multiselect-react-dropdown";
import GenericTableSkeleton from "../../Frontend/skeletons/tableSkeleton/genericTableSkeleton";
import TagOverflowHandler from "../../Frontend/uiUtils/TagOverflowHandler";
import ResizableDivForTag from "../../Frontend/uiUtils/resizeobs/ResizableDivForTag";

export default function AccountList() {
  const [editModeAccountId, setEditModeAccountId] = useState(null);
  const [dropdownVisible, setDropdownVisible] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const { user, my_favourites, setUserAssingedAccounts } = useUser();
  const [assignedUsersMap, setAssignedUsersMap] = useState({});

  const { updateMyReportContext, loading, allAccounts } =
    useContext(AccountListContext);
  const [successMessage, setSuccessMessage] = useState("");
  const [error, setError] = useState("");
  const [loader, setLoader] = useState(false);

  const [currentRecords, setCurrentRecords] = useState([]); // State for current page records
  const [currentPage, setCurrentPage] = useState(1);
  const [perPage] = useState(10);
  const [sortField, setSortField] = useState("account_name");
  const [sortOrder, setSortOrder] = useState("asc");
  const [sortedRecords, setSortedRecords] = useState([]);
  const [totalPages, setTotalPages] = useState(0);
  const [all_accounts, setAllAccountsData] = useState([]);
  const [user_list, setUserList] = useState([]);
  const [showAddAccModal, setShowAddAccModal] = useState(false);
  const [loader4AddingAccount, setLoader4AddingAccount] = useState(false);

  const [newClientName, setNewClientName] = useState("");
  const [newClientCode, setNewClientCode] = useState("");
  const [newAccountName, setNewAccountName] = useState("");
  const [newAccountCode, setNewAccountCode] = useState("");
  const [userCurrentRole, setUserCurrentRole] = useState(user?.role_key || "");
  const [addApiError, setApiError] = useState("");
  const [messageInfo, setMessageInfo] = useState({});
  const [filteredRecords, setFilteredRecords] = useState([]);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  useEffect(() => {
    // Function to handle the click event
    const handleClickAnywhere = (event) => {
      const clickedElement = event.target;

      // Get the parent of the clicked element
      const parentElement = clickedElement.parentElement.parentElement;
      if (!parentElement) return;

      // Find the sibling with class 'optionListContainer'
      const optionList = parentElement.querySelector('.optionListContainer');
      if (optionList) {
        // Check if it also has class 'displayBlock'
        if (optionList.classList.contains('displayBlock')) {
          setIsDropdownOpen(true)
        } else {
          setIsDropdownOpen(false)
        }
      }
    };

    // Attach the event listener to the document
    document.addEventListener('click', handleClickAnywhere);

    // Clean up the event listener when the component unmounts
    return () => {
      document.removeEventListener('click', handleClickAnywhere);
    };
  }, []); // Empty dependency array ensures this runs only once on mount

  const handleSearch = (e) => {
    setSearchTerm(e.target.value);
  };

  useEffect(() => {
    setCurrentPage(1);
  }, [searchTerm]);

  useEffect(() => {
    // Fetch company list from the API
    const fetchUsers = async () => {
      setLoader(true);
      try {
        const filterData = {
          is_active: 1,
          is_deleted: 0,
          company_id: user?.company_id,
          limit: 1000,
        };
        const response = await api.get("/users/get_users_list", {
          params: filterData,
        });
        let users = [...response.data.result.list];
        users = users.map((user) => {
          return {
            id: user.id,
            assigned_accounts: user.assigned_accounts,
            display_name: user.firstname + " " + user.lastname,
          };
        });
        setUserList(users);
      } catch (error) {
        console.error("Error fetching users:", error);
      }
      setLoader(false);
    };

    if (user?.company_id) {
      fetchUsers();
    }
  }, [user?.company_id]);

  useEffect(() => {
    if (user_list.length && allAccounts.length) {
      const newAssignedMap = {};
      allAccounts.forEach((account) => {
        newAssignedMap[account._id] = user_list.filter(
          (user) =>
            Array.isArray(user?.assigned_accounts) &&
            user.assigned_accounts?.includes(account?.company_code)
        );
      });
      setAssignedUsersMap(newAssignedMap);
    }
  }, [user_list, allAccounts]);

  const handleChangeUsersSelect = (selectedList, selectedItem, accountId) => {
    setAssignedUsersMap((prev) => ({
      ...prev,
      [accountId]: selectedList,
    }));
  };

  const handleRemoveUsersSelect = (selectedList, removedItem, accountId) => {
    setAssignedUsersMap((prev) => ({
      ...prev,
      [accountId]: selectedList,
    }));
  };

  const assignUsersToAccount = async (account) => {
    // console.log("assignedUsersMap ::: ", assignedUsersMap)

    const usersToAssign = assignedUsersMap[account?._id] || [];
    const user_ids = usersToAssign.map((user) => user.id);

    const res = await api.post("/users/assign_account_to_users", {
      account_code: account.company_code,
      user_ids: user_ids,
    });

    setDropdownVisible(null);

    // call API or perform assignment
    // console.log("Assigning", usersToAssign, "to", account?._id, user_ids);
  };

  useEffect(() => {
    setAllAccountsData(allAccounts);
  }, [allAccounts]);

  const handleSort = (field) => {
    const order = sortField === field && sortOrder === "asc" ? "desc" : "asc";
    setCurrentPage(1);
    setSortField(field);
    setSortOrder(order);
  };

  const getSortedRecords = () => {
    const sortedRecords = all_accounts.sort((a, b) => {

      let is_numeric = false;
      let dataSortField = "financials.0.financials.0.value";

      if (sortField === "isFavourite") {
        dataSortField = "isFavourite";
        is_numeric = true;
      } else if (sortField === "account_name") {
        dataSortField = "name";
      } else if (sortField === "industry_name") {
        dataSortField = "company_details.0.trbc_industry_name";
      } else if (sortField === "relevance_score") {
        dataSortField = "relevance_score";
        is_numeric = true;
      } else if (sortField === "revenue") {
        dataSortField = "financials.0.financials.0.value";
        is_numeric = true;
      } else if (sortField === "number_of_users") {
        dataSortField = "number_of_users";
        a.number_of_users = assignedUsersMap[a._id]?.length || 0;
        b.number_of_users = assignedUsersMap[b._id]?.length || 0;
        is_numeric = true;
      }

      // Helper function to access nested properties by string path
      const getNestedValue = (obj, path) =>
        path.split(".").reduce((acc, part) => acc && acc[part], obj);

      const valueA = getNestedValue(a, dataSortField);
      const valueB = getNestedValue(b, dataSortField);

      // Handling NaN or undefined values
      const numA = is_numeric ? parseFloat(valueA) : valueA;
      const numB = is_numeric ? parseFloat(valueB) : valueB;

      // Handle NaN or undefined by pushing to the bottom
      if (valueA === undefined || valueA === null || valueA === "")
        return sortOrder === "asc" ? -1 : 1;
      if (valueB === undefined || valueB === null || valueB === "")
        return sortOrder === "asc" ? 1 : -1;

      // Normal comparison
      if (typeof valueA === "string" && typeof valueB === "string") {
        return sortOrder === "asc"
          ? valueA.localeCompare(valueB)
          : valueB.localeCompare(valueA);
      } else {
        if (valueA < valueB) return sortOrder === "asc" ? -1 : 1;
        if (valueA > valueB) return sortOrder === "asc" ? 1 : -1;
      }

      return 0;
    });

    return sortedRecords;
  };

  useEffect(() => {
    if (all_accounts.length) {
      const sortedRecords = getSortedRecords();
      setSortedRecords(sortedRecords);
    } else {
      setSortedRecords([]);
    }
  }, [all_accounts, sortField, sortOrder]);

  useEffect(() => {
    const filteredRecords = sortedRecords.filter((record) =>
      record.name.toLowerCase().includes(searchTerm.toLowerCase())
    );
    const indexOfLastRecord = currentPage * perPage;
    const indexOfFirstRecord = indexOfLastRecord - perPage;
    // const current_records = sortedRecords.slice(indexOfFirstRecord, indexOfLastRecord);
    const current_records = filteredRecords.slice(
      indexOfFirstRecord,
      indexOfLastRecord
    );

    setCurrentRecords(current_records); // Set current page records
    setTotalPages(Math.ceil(filteredRecords.length / perPage));

    setFilteredRecords(filteredRecords);
  }, [currentPage, sortedRecords, sortField, sortOrder, searchTerm]);

  const handleFirstPage = () => {
    setCurrentPage(1);
  };

  const handleLastPage = () => {
    setCurrentPage(totalPages);
  };

  const handlePrevPage = () => {
    if (currentPage > 1) setCurrentPage(currentPage - 1);
  };

  const handleNextPage = () => {
    if (currentPage < totalPages) setCurrentPage(currentPage + 1);
  };

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const getPageNumbers = () => {
    const pageNumbers = [];
    const startPage = Math.max(1, currentPage - 2);
    const endPage = Math.min(totalPages, currentPage + 2);
    for (let i = startPage; i <= endPage; i++) {
      pageNumbers.push(i);
    }
    return pageNumbers;
  };

  useEffect(() => {
    setNewClientName(user?.company_name);
    setNewClientCode(user?.company_id);
    setUserCurrentRole(user?.role_key);
    updateMyReportContext();
  }, [user]);

  const handleAutoCompleteChange = (e) => {
    const { name, value, code } = e.target;
    if (name === "account_name") {
      setNewAccountName(value);
      setNewAccountCode(code);
    }
  };

  const handleAddAccount = async () => {
    try {
      setLoader4AddingAccount(true);

      const response = await api.post("/accounts/add_account", {
        account_name: newAccountName?.trim(),
        account_code: newAccountCode?.trim(),
        client_name: newClientName?.trim(),
        client_code: newClientCode?.trim(),
        add_account_to_v2: true,
      });

      if (response.data.status === 201 || response.data.status === 200) {
        var assigned_accounts = user?.assigned_accounts
          ? [...user.assigned_accounts]
          : [];
        assigned_accounts.push(newAccountCode?.trim() || "AA");
        setUserAssingedAccounts(assigned_accounts);

        // await updateMyReportContext();
        handleAddAccClose();

        setMessageInfo({
          message_type: "success",
          message: "Account request has been sent successfully.",
        });
      } else {
        setApiError(
          response.data.result.message ||
            "An error occurred while saving the company."
        );
      }
      setLoader4AddingAccount(false);
    } catch (error) {
      if (error.response) {
        const errors = error.response.data?.result?.errors || [];

        if (Array.isArray(errors) && errors.length > 0) {
          const messages = errors.map((err) => err.message).join("\n");
          setApiError(messages || "Failed to add account.");
        } else {
          const fallback =
            error.response.data?.message || "Something went wrong.";
          setApiError(fallback || "Failed to add account.");
        }
      } else if (error.request) {
        // The request was made but no response was received
        console.error("No response from server", error.request);
        setApiError("No response from server. Please check your network.");
      } else {
        // Something happened in setting up the request
        console.error("Error", error.message);
        setApiError("Error : " + error.message);
      }
      setLoader4AddingAccount(false);
    }
    setTimeout(() => {
      setApiError("");
    }, 5000);
    setLoader(false);
  };

  const modalAddAccount = () => {
    setApiError("");
    setShowAddAccModal(true);
  };

  const handleAddAccClose = () => {
    setShowAddAccModal(false);
    setNewAccountName("");
    setNewAccountCode("");
    setApiError("");
  };

  const getListTags = (my_data,idx) => {
    const tabConfig =  my_data.map((item)=>( {
        key:idx,
        label:item['display_name']
      })
    )
    return <ResizableDivForTag handleSideCard={() => {}} items={tabConfig} rowData={{}} />

    // return <TagOverflowHandler  handleSideCard={()=>null} tabConfig={tabConfig} rowData={{}} showMinimumCount={2} />
  }

  return (
    <div className="col-md-12 mt-2">
      {/* {loading && <ScreenLoader />} */}

      {loading ? (
        <GenericTableSkeleton colCount={4} rowCount={10} />
      ) : (
        <>
          <div className="row">
            <div className="col-md-3">
              {/* <h4 className="blue add_user_heading">Account List</h4> */}
              <h5 class="target_head mb-0">Account List</h5>
            </div>

            <div className="col-md-9 align-right pb-3">
              <div className="d-flex pull-right">
                <input
                  type="text"
                  className="form-control mr-3"
                  placeholder="Search..."
                  style={{
                    width: "350px",
                    height: "32px",
                    padding: "8px 4px 8px 12px",
                    border: "0.5px solid #42464847",
                    backgroundColor: "#FFFFFF",
                    fontSize: "12.5px",
                    lineHeight: "15.63px",
                    fontWeight: "500",
                    color: "#9595A1",
                  }}
                  value={searchTerm}
                  onChange={(e) => handleSearch(e)}
                />

                <Link
                  className="profile_buttons btn font12"
                  to="#"
                  onClick={modalAddAccount}
                >
                  <i className="fa fa-plus" aria-hidden="true"></i> Add Account
                </Link>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-md-12">
              <div className="accounts_table_block ">
                <div className="table-responsive_1">
                  <table className="accounts_table assign_users_to_accounts_table custom-resizable-table">
                    <thead className="accounts_thead">
                      <tr className="tr_growth">
                        <th
                          className="accounts_th cursorP"
                          width="350"
                          onClick={() => handleSort("account_name")}
                        >
                          Company Name{" "}
                          {sortField === "account_name" &&
                            (sortOrder === "asc" ? "▲" : "▼")}
                        </th>
                        <th
                          className="accounts_th cursorP"
                          width="250"
                          onClick={() => handleSort("industry_name")}
                        >
                          Industry{" "}
                          {sortField === "industry_name" &&
                            (sortOrder === "asc" ? "▲" : "▼")}
                        </th>

                        <th
                          className="accounts_th cursorP text_left px-4"
                          width="300"
                          style={{maxWidth: '400px'}}
                          onClick={() => handleSort('number_of_users')}
                        >
                          Account Users 
                          {sortField === "number_of_users" &&
                            (sortOrder === "asc" ? "▲" : "▼")}
                        </th>

                        <th
                          className="accounts_th cursorP text_right"
                          width="150"
                        >
                          {" "}
                          Action{" "}
                        </th>
                      </tr>
                    </thead>
                    <tbody className="accounts_tbody">
                      {currentRecords.map((account, index) => {
                        let accountStatus = account.status;
                        account.relevance_score = account?.relevance_score
                          ? account.relevance_score
                          : Math.floor(Math.random() * (90 - 61) + 61);
                        let account_displayname = account?.company_details?.[0]
                          ?.display_name
                          ? account?.company_details?.[0]?.display_name
                          : account.name;

                        return (
                          <tr
                            key={index}
                            className={`${
                              accountStatus === 1 ? "" : "geting_ready_tr"
                            }`}
                          >
                            {accountStatus === 1 ? (
                              <>
                                <td className="accounts_td">
                                  <div className="use_case_text d-flex align-items-center">
                                    <Link
                                      className="link"
                                      to={`/account_details/${account._id}/${encodeURIComponent(account.name)}/${encodeURIComponent(account?.client)}`}
                                    >
                                      <img
                                        width=""
                                        src={`${COMPANY_LOGO_BASE_URL}${encodeURIComponent(
                                          account?.name
                                        )}`}
                                        alt="image"
                                        className="all_account_icon_img"
                                      />
                                    </Link>
                                    <Link
                                      className="link"
                                      to={`/account_details/${account._id}/${encodeURIComponent(account.name)}/${encodeURIComponent(account?.client)}`}
                                    >
                                      <p className="account_name mb-0">
                                        {account_displayname}
                                      </p>
                                    </Link>
                                  </div>
                                </td>
                                <td className="accounts_td">
                                  {
                                    account?.company_details?.[0]
                                      ?.trbc_industry_name
                                  }
                                </td>

                                <td className="accounts_td text_left px-4" style={{maxWidth: '415px'}}>
                                  {editModeAccountId === account._id ? (
                                    <Multiselect
                                      name="assigned_users"
                                      avoidHighlightFirstOption
                                      selectedValues={
                                        assignedUsersMap[account._id] || []
                                      }
                                      options={user_list}
                                      onSelect={(selectedList, selectedItem) =>
                                        handleChangeUsersSelect(
                                          selectedList,
                                          selectedItem,
                                          account._id
                                        )
                                      }
                                      onRemove={(selectedList, removedItem) =>
                                        handleRemoveUsersSelect(
                                          selectedList,
                                          removedItem,
                                          account._id
                                        )
                                      }
                                      displayValue="display_name"
                                      showCheckbox={true}
                                      placeholder="Select Users"
                                    />
                                  ) : (
                                    <div className="gtr-cell-content-container">
                                      
                                      {getListTags(assignedUsersMap[account._id] || [])}

                                      {/* {(
                                        assignedUsersMap[account._id] || []
                                      ).map((user, idx) => (
                                        <span
                                          key={user.id}
                                          className="badge bg-secondary mt-1 mr-1 py-1 font12"
                                        >
                                          {user.display_name}
                                        </span>
                                      ))} */}
                                    
                                    </div>

                                    
                                  )}
                                </td>

                                <td className="pr-2">
                                  <Button
                                    type="button"
                                    className="profile_buttons btn-sm pull-right font12"
                                    disabled={
                                      dropdownVisible !== null &&
                                      editModeAccountId !== account._id
                                    }
                                    onClick={() => {
                                      setDropdownVisible(account._id);
                                      if (editModeAccountId === account._id) {
                                        assignUsersToAccount(account);
                                        setEditModeAccountId(null); // Exit edit mode
                                      } else {
                                        setEditModeAccountId(account._id); // Enter edit mode
                                      }
                                    }}
                                  >
                                    {editModeAccountId === account._id
                                      ? "Update Users"
                                      : "Assign Users"}
                                  </Button>
                                </td>
                              </>
                            ) : (
                              <>
                                <td className="accounts_td ">
                                  <div className="use_case_text d-flex align-items-center">
                                    <Link className="link">
                                      <img
                                        width=""
                                        src={`${COMPANY_LOGO_BASE_URL}${encodeURIComponent(
                                          account?.name
                                        )}`}
                                        alt="image"
                                        className="all_account_icon_img"
                                      />
                                    </Link>
                                    <Link className="link">
                                      <span className="account_name">
                                        {account.name}{" "}
                                      </span>
                                    </Link>
                                  </div>
                                </td>
                                <td colSpan={8}>
                                  <div className="circle_ready new_blue_circle_ready">
                                    <div id="new_blue_outer-circle">
                                      <div id="new_blue_inner-circle"></div>
                                    </div>
                                    <p className="new_blue_getting_ready">
                                      Account setup is in progress.
                                    </p>
                                  </div>
                                </td>
                              </>
                            )}
                          </tr>
                        );
                      })}

                      {/* {isDropdownOpen && <tr>
                        <td colSpan="4" height="250"></td>
                      </tr>} */}
                    </tbody>
                  </table>
                </div>
                <div>
                  <nav className="table_pagination_custom">
                    {all_accounts.length > perPage && (
                      <ul className="showing-per-page-info pl-0 ml-0 font13">
                        <li className="page-item">
                          <span className="showing">Showing </span>{" "}
                          {all_accounts.length > 0
                            ? (currentPage - 1) * perPage + 1
                            : 0}
                          -
                          {Math.min(
                            currentPage * perPage,
                            filteredRecords.length
                          )}{" "}
                          of {numberWithCommas(filteredRecords.length)}
                        </li>
                      </ul>
                    )}

                    {all_accounts.length > perPage && (
                      <ul className="pagination">
                        <li
                          className={`page-item ${
                            currentPage === 1 ? "disabled" : ""
                          }`}
                        >
                          <button
                            onClick={handleFirstPage}
                            className="page-link"
                          >
                            First
                          </button>
                        </li>
                        <li
                          className={`page-item ${
                            currentPage === 1 ? "disabled" : ""
                          }`}
                        >
                          <button
                            onClick={handlePrevPage}
                            className="page-link"
                          >
                            <i
                              className="fa fa-angle-left"
                              aria-hidden="true"
                            ></i>
                          </button>
                        </li>
                        {getPageNumbers().map((pageNumber) => (
                          <li
                            key={pageNumber}
                            className={`page-item ${
                              pageNumber === currentPage ? "active" : ""
                            }`}
                          >
                            <button
                              onClick={() => handlePageChange(pageNumber)}
                              className="page-link"
                            >
                              {pageNumber}
                            </button>
                          </li>
                        ))}
                        <li
                          className={`page-item ${
                            currentPage === totalPages ? "disabled" : ""
                          }`}
                        >
                          <button
                            onClick={handleNextPage}
                            className="page-link"
                          >
                            <i
                              className="fa fa-angle-right"
                              aria-hidden="true"
                            ></i>
                          </button>
                        </li>
                        <li
                          className={`page-item ${
                            currentPage === totalPages ? "disabled" : ""
                          }`}
                        >
                          <button
                            onClick={handleLastPage}
                            className="page-link"
                          >
                            Last
                          </button>
                        </li>
                      </ul>
                    )}
                  </nav>
                </div>
              </div>
            </div>
          </div>
        </>
      )}

      <Modal show={showAddAccModal} onHide={handleAddAccClose} centered>
        <Modal.Header closeButton>
          <Modal.Title>Add Account</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="row">
            {addApiError && (
              <div className="alert alert-danger">{addApiError}</div>
            )}
          </div>

          <div className="row">
            <div className="col-md-12">
              <label
                htmlFor="labelAccountName"
                className="form-label custom_label"
              >
                Account Name <span className="red">*</span>
              </label>
              <Autocomplete
                autocomplete_for="add_account"
                name="account_name"
                key="suggest_account_name"
                value={newAccountName}
                onChange={handleAutoCompleteChange}
                placeholder="Account Name"
                element_field_key="account_name"
                apiUrl="/company/search_company"
                labelKey="name"
                valueKey="ciq_id"
              />
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleAddAccClose}>
            Close
          </Button>
          <Button
            disabled={loader4AddingAccount}
            variant="profile_buttons"
            className="profile_buttons font12"
            onClick={handleAddAccount}
          >
            {loader4AddingAccount ? (
              <i className="fa fa-spinner fa-spin"></i>
            ) : (
              <></>
            )}{" "}
            Add Account
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}
